import React, {useEffect, useRef, useState} from 'react';
import Box from "@mui/material/Box";
import {TextField} from "@mui/material";
import DateTimeInput from "../../../../components/UI/filter/DateTimeInput";
import DateTimeUtil from "../../../../utils/common/DateTimeUtil";
import IssuanceService from "../../../../API/orders/prodaction.issueedge/issuance/IssuanceService";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import ButtonCreate from "../../../../components/UI/button/ButtonCreate";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../../Constants";
import dayjs from "dayjs";
import MaterialWarehouseService from "../../../../API/orders/warehouse/material/MaterialWarehouseService";
import UtilityService from "../../../../API/common/UtilityService";
import InStockTable from "./InStockTable";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import FileDownloadController from "../../../../API/organization/FileDownloadController";
import ButtonExport from "../../../../components/UI/button/ButtonExport";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {InStockTableFilterData} from "../../../../data/FilterTables/InStockTableFilterData";

const InStock = () => {
        const [startInStock, setStartInStock] = useState(dayjs(Date.now()));
        const [dataInStock, setDataInStock] = useState(null);
        const [dataAllStock, setDataAllInStock] = useState([]);
        const [alertData, setAlertData] = useState({});

        const [currencyMap, setCurrencyMap] = useState(new Map);
        const [currencies, setCurrencies] = useState()
        const firstRender = useRef(true);
        const [isLoading, setIsLoading] = useState(true);
        const [reportReceived, setReportReceived] = useState(false);
        const [filteredData, setFilteredData] = useState(dataAllStock)
        const [globalFilter, setGlobalFilter] = useState('');
        const [columnsFilter, setColumnsFilter] = useState([]);

        const [tableOptions, setTableOptions] = useState({
            pageIndex: 0,
            pageSize: 100,
            totalElements: 0,
            searchData: ""
        })

        useEffect(() => {
            setIsLoading(true)
            if (firstRender.current) {
                UtilityService.getCurrencies()
                    .then(function (response) {
                        const data = response.data;
                        data.forEach((c) => {
                            currencyMap.set(c.id, c);
                        });
                        setCurrencies(data)
                    }).catch(function (error) {
                    handleModalAlert(error)
                })
                ;
            } else {
            }
        }, []);

        const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
            const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
            const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

            const data = [...prevData]
            const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, InStockTableFilterData) : data
            const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
                return calcFilterData(accumulator, currentValue?.value, [InStockTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
            }, globalFilterData);

            setFilteredData(newData)

            tableOptionsHandle({
                ...tableOptions,
                totalElements: newData.length,
                pageSize: pageSize ? pageSize : tableOptions?.pageSize
            })

            if (isColumnFilters) {
                setColumnsFilter(searchQuery)
            } else {
                setGlobalFilter(searchQuery || "")
                if (searchQuery !== globalFilter) {
                    EditLocalStoragePagesData(`/organization/in-stock`, "searchQuery", searchQuery)
                }
            }
        }

        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = pagesData[`/organization/in-stock`]?.pageSize
            const searchQuery = pagesData[`/organization/in-stock`]?.searchQuery

            return {searchQuery, pageSize}
        }

        const handleModalAlert = (message, type = "error") => {
            setAlertData({
                type: type,
                open: true,
                message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
            })
        }

        const applyInStock = () => {
            IssuanceService.getInStock(DateTimeUtil.convertToJavaDateTime(startInStock)).then(function (response) {
                const data = response.data;
                setDataInStock(data);
                handleModalAlert("Вычислено", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
        const applyAllInStock = () => {
            const {searchQuery, pageSize} = getStartPageSize()
            MaterialWarehouseService.getAllInStock(DateTimeUtil.convertToJavaDateTime(startInStock)).then(function (response) {
                const data = response.data;
                setDataAllInStock(data);
                setReportReceived(true)
                handleSearchQuery(searchQuery, data, pageSize)
                handleModalAlert("Отчёт получен", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
        const tableOptionsHandle = (nextState, currTab) => {
            setTableOptions(nextState)
            if (nextState.pageSize !== tableOptions.pageSize) {
                EditLocalStoragePagesData(`/organization/in-stock`, "pageSize", nextState.pageSize)
            }
        }

        return (
            <Box sx={{padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={"На складе"}
                    path={[
                        {name: "Главная", href: "/"},
                    ]}/>
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                    На складе
                </Typography>
                <Box sx={{display: "flex", gap: "50px", paddingTop: "30px"}}>
                    <Box sx={{display: "flex", gap: "20px", alignItems: "end"}}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '0.5rem',
                                flexWrap: 'wrap',
                                alignItems: "end"
                            }}>
                            <DateTimeInput
                                value={startInStock}
                                setValue={setStartInStock}
                                variant={"outlined"}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '0.5rem',

                                    flexWrap: 'wrap',
                                }}
                            >
                                <ButtonCreate
                                    text={"Вычислить на складе"}
                                    onClick={applyInStock}
                                    icon={false}
                                    width={190}
                                    disabled={!startInStock}/>
                            </Box>
                        </Box>
                        <TextField
                            size={"small"}
                            margin="none"
                            key={"base"}
                            label={"В базовой валюте"}
                            variant="standard"
                            name={"base"}
                            disabled={true}
                            value={dataInStock === null ? "" : dataInStock.first.toFixed(2)}
                        />
                        <TextField
                            size={"small"}
                            margin="none"
                            key={"alternative"}
                            label={"В Альтернативной валюте"}
                            variant="standard"
                            name={"base"}
                            disabled={true}
                            value={dataInStock === null ? "" : dataInStock.second.toFixed(2)}
                        />
                    </Box>
                </Box>
                <Box sx={{padding: "30px 0", display: 'flex', gap: "10px",}}>
                    <ButtonCreate
                        text={"Получить полный отчёт"}
                        onClick={applyAllInStock}
                        icon={false}
                        width={200}
                        disabled={!startInStock}/>
                    <ButtonExport
                        text={"Скачать отчёт"}
                        width={130}
                        api={() => FileDownloadController.exportMaterialsInStock(DateTimeUtil.convertToJavaDateTime(startInStock))}
                        handleModalAlert={handleModalAlert}/>
                </Box>

                <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                    return {...alert, open: false}
                })}/>
                {reportReceived &&
                    <InStockTable
                        data={dataAllStock}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        globalFilter={globalFilter}
                        filteredData={filteredData}
                        handleSearchQuery={handleSearchQuery}
                        columnsFilter={columnsFilter}/>}
            </Box>

        );
    }
;

export default InStock;